/**
 * Simple password requirements component
 * @param {*} isValid If the requirements are met
 * @param {*} message The message to display
 */
export default function PasswordRequirement(isValid, message) {
  return (
    <li className={`${isValid ? 'valid' : 'invalid'}`}>
      <i
        className={`icon ${
          isValid ? 'bi-check-circle' : 'bi-exclamation-circle'
        }`}
      ></i>
      {message}
    </li>
  )
}
